import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlanAlertComponent } from './plan-alert.component';
import { MatIconModule } from '@angular/material/icon';
import { MbPlansModule } from '@app/modules/trading/modules/mb-plans/mb-plans.module';



@NgModule({
  declarations: [PlanAlertComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MbPlansModule,
  ],
  exports: [
    PlanAlertComponent
  ]
})
export class PlanAlertModule { }
